import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface initialState {
  page: number;
  pageSize: number;
}

const initialState: initialState = {
  page: 1,
  pageSize: 10,
};

const organizationsSlice = createSlice({
  name: "organizations",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
  },
});

export const {
  setPage,
  setPageSize,
} = organizationsSlice.actions;

export default organizationsSlice.reducer;
